import { IModuleProps } from '../core/utils/modules';

import routes from './routes';

export default {
    name: 'users',
    routes,
} as IModuleProps;
